function initScroll() {
  document.querySelectorAll(".product-table-wrapper").forEach(wrapper => {
    if (wrapper.dataset.scrollInit) return;
    wrapper.dataset.scrollInit = "true";
    wrapper.style.position = "relative";

    // ヒント
    if (!wrapper.querySelector(".product-table-scroll-hint")) {
      const hint = document.createElement("div");
      hint.className = "product-table-scroll-hint";
      hint.textContent = "⇔ 横にスクロールできます";
      hint.style.pointerEvents = "none";
      wrapper.appendChild(hint);
      setTimeout(() => {
        hint.style.transition = "opacity 0.8s";
        hint.style.opacity = "0";
        setTimeout(() => hint.remove(), 800);
      }, 5000);
    }

    // ドラッグスクロール
    let isDown = false, startX, scrollLeft;
    wrapper.addEventListener("mousedown", e => {
      isDown = true;
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });
    wrapper.addEventListener("mouseleave", () => isDown = false);
    wrapper.addEventListener("mouseup", () => isDown = false);
    wrapper.addEventListener("mousemove", e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      wrapper.scrollLeft = scrollLeft - (x - startX);
    });
  });
}

// 1秒ごとにチェック（Ajax遷移後も確実に効く）
setInterval(initScroll, 1000);